export const Themes = [
    {
        id: "demo",
        docTitle: "StarGame",
        label: "Demo",
        enabled: true,
        hosts: ["demo.stargame.one", "debug.stargame.one", "localhost"]
    },
    {
        id: "stargame",
        docTitle: "StarGame",
        label: "Classic",
        enabled: true,
        allowWebAuthN: true,
        allowSplitScreen: true,
        hosts: ["stargame.one", "netwin4.fun", "debug.stargame.one", "cosmo4fun.com", "localhost", "dev.local"]
    },
    {
        id: "stargame_mobile",
        docTitle: "StarGame",
        label: "Mobile",
        enabled: true,
        allowWebAuthN: true,
        hideChats: true,
        hosts: ["mobile.stargame.one", "stargame.one", "debug.stargame.one", "localhost"]
    },
    {
        id: "riviera",
        docTitle: "StarGame",
        label: "Riviera",
        allowWebAuthN: true,
        enabled: true,
        hosts: ["stargame.one", "debug.stargame.one", "localhost"]
    },
    {
        id: "casinoexe",
        docTitle: "StarGame",
        label: "Casino.exe",
        enabled: true,
        allowWebAuthN: true,
        hideChats: true,
        hosts: ["stargame.one", "debug.stargame.one", "localhost"]
    },
    {
        id: "firekirin",
        docTitle: "FireKirin",
        label: "Firekirin",
        allowWebAuthN: true,
        enabled: true,
        hideChats: true,
        hosts: ["debug.stargame.one", "localhost", "firekirin.one"]
    },
    {
        id: "firekirinPlusLive",
        path: "firekirin",
        docTitle: "FireKirin",
        label: "FireKirin + Live",
        enabled: true,
        hideChats: true,
        hosts: ["debug.stargame.one", "localhost", "firekirinlive.com"]
    },
    {
        id: "firekirinLive",
        path: "firekirin",
        docTitle: "FireKirin",
        label: "FireKirin Live",
        enabled: true,
        hideChats: true,
        hosts: ["debug.stargame.one", "localhost", "firekirin.live"]
    },
    {
        id: "dragon-skill",
        docTitle: "Dragon Skill",
        label: "Dragon Skill",
        enabled: true,
        hideChats: true,
        hosts: ["dragon-skill.com", "debug.stargame.one", "localhost"]
    },
    {
        id: "captain-america",
        docTitle: "One 2 Bet",
        label: "Captain America",
        enabled: true,
        hideChats: true,
        hosts: ["one2bet.games", "debug.stargame.one", "localhost"]
    },
    {
        id: "asia-games",
        docTitle: "Casino",
        label: "Asia Games",
        enabled: true,
        hideChats: true,
        safeVendors: true,
        hosts: ["bs-local.com", "asia.games", "www.asia.games", "mobile.asia.games", "row.solutions", "www.row.solutions", "mobile.row.solutions", "play.asia.games", "debug.stargame.one", "localhost"]
    },
    {
        id: "supervegas",
        docTitle: "Big Winner",
        label: "Super Vegas",
        enabled: true,
        hideChats: true,
        hosts: ["usa.bigwinner.pro", "www.usa.bigwinner.pro", "bigwinner.pro", "www.bigwinner.pro", "debug.stargame.one", "localhost"]
    },
    {
        id: "playrealslot",
        docTitle: "Play Real Slot",
        path: "supervegas",
        label: "Play Real Slot",
        enabled: true,
        hideChats: true,
        hosts: ["playrealslot.com", "www.playrealslot.com", "debug.stargame.one", "localhost"]
    },
    {
        id: "luckywinner",
        docTitle: "Lucky Winner",
        path: "supervegas",
        label: "Lucky Winner",
        enabled: true,
        hideChats: true,
        hosts: ["luckywinne.com", "www.luckywinne.com", "debug.stargame.one", "localhost"]
    },
    {
        id: "savanna",
        docTitle: "Holla Africa",
        label: "Savanna",
        enabled: true,
        hideChats: true,
        safeVendors: false,
        installPwa: true,
        hosts: ["bs-local.com", "hollaafrica.one", "shop@holla-africa.com", "www.hollaafrica.one", "hollaafrica.com", "www.hollaafrica.com", "debug.stargame.one", "localhost"]
    },
    {
        id: "savannaPro",
        path: "savanna",
        regUser: {
            service: "grandcom",
        },
        docTitle: "Holla Africa",
        label: "Savanna Pro",
        enabled: true,
        hideChats: true,
        safeVendors: false,
        installPwa: true,
        hosts: ["bs-local.com", "holla-africa.com", "www.holla-africa.com", "debug.stargame.one", "localhost"]
    },
    {
        id: "live",
        docTitle: "Live Dealers",
        label: "Live",
        enabled: true,
        hideChats: true,
        safeVendors: false,
        hosts: ["live.stargame.games", "www.live.stargame.games", "apiserver.solutions", "orfelin.com", "evolive.net", "pragmaticlive.net", "localhost"]
    },
    {
        id: "h24casino",
        docTitle: "H24 Casino",
        label: "H24 Casino",
        enabled: true,
        hideChats: true,
        safeVendors: false,
        userWallet: true,
        hosts: ["h24casino.com", "www.h24casino.com", "localhost"]
    },
    {
        id: "royale-slots",
        docTitle: "Royale Slots",
        label: "Royale Slots",
        enabled: true,
        hideChats: true,
        safeVendors: false,
        regUser: {
            service: "bulksms",
            hallId: 12160
        },
        hosts: ["bs-local.com", "royale-slots.com", "www.royale-slots.com", "debug.stargame.one", "localhost"]
    },
    {
        id: "sbslot",
        docTitle: "SB Slot",
        label: "SB Slot",
        enabled: true,
        hideChats: true,
        safeVendors: false,
        appVersion: 2,
        regUser: {
            service: "bulksms",
        },
        hosts: ["bs-local.com", "sbslot.com", "www.sbslot.com", "debug.stargame.one", "localhost"]
    },
    {
        id: "slotshub",
        path: "sbslot",
        docTitle: "Slots Hub",
        label: "Slots Hub",
        enabled: true,
        hideChats: true,
        safeVendors: false,
        appVersion: 2,
        regUser: {
            service: "bulksms",
        },
        hosts: ["slots-hub.gr", "www.slots-hub.gr", "debug.stargame.one", "localhost"]
    },
    {
        id: "realbet",
        docTitle: "Real Bet",
        label: "Real Bet",
        enabled: true,
        hideChats: true,
        safeVendors: false,
        allowSplitScreen: true,
        hosts: ["bs-local.com", "realbet.games", "www.realbet.games", "debug.stargame.one", "localhost"]
    },
    {
        id: "thegoldcity",
        docTitle: "The Gold City",
        label: "The Gold City",
        enabled: true,
        hideChats: true,
        safeVendors: false,
        hosts: ["bs-local.com", "thegold.city", "www.thegold.city", "debug.stargame.one", "localhost"]
    },
    {
        id: "vegaswin",
        docTitle: "Vegas Win",
        label: "Vegas Win",
        enabled: true,
        hosts: ["vegaswin.co", "debug.stargame.one", "localhost"]
    },
];
